module.exports = __webpack_public_path__ + "static/media/blog-01.25b90b6e.jpg";